import Form from '../components/Form.js'
import global from '../utils/global.js'
import Page from './Page.js'

export default class HomePage extends Page {

    static instance

    constructor(parent) {

        if ( HomePage.instance ) return HomePage.instance
        super( 'home' )
        HomePage.instance = this
        this.parent = parent
        global.views.push( this.view )

        
    }   

    afterEnter({next}){

        const formElement = next.container.querySelector(".booking_form")
        console.log('booking page', formElement)
        if(formElement){
            this.bookingForm = new Form(formElement,this)
        }

        console.log(this.bookingForm)
    }

    afterLeave(){

        if(this.bookingForm){
            this.bookingForm.destroy()
            this.bookingForm = null
        }

    }

}
